import { SignupStepResponse } from './types';
import { HEADERS_JSON } from '@/common/api/config';
import { catchError } from '@/common/api/utils';
import { GATEWAY_URL } from '@/config';

export const fetchSignupStep = async (
  token: string
): Promise<SignupStepResponse> => {
  const response = await fetch(
    `${GATEWAY_URL}/application/step?token=${token}`,
    {
      method: 'GET',
      headers: HEADERS_JSON,
    }
  );

  if (!response.ok) {
    localStorage.clear();
  }

  await catchError(response);
  return await response.json();
};
